import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_API_SUCCESS,
  LOGIN_USER_ERROR,
  SYNC_USER_INFO,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_ERROR,
  LOGOUT_USER,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  UPDATE_SELECTED_EMPLOYEE,
  SELECT_ACTIVE_ACCOUNT,
} from "../action/index";
// import {isTokenValid} from './saga';
import { getFromStorage, platform } from "../../functions/utils";

const INIT_STATE = {
  user:
    platform == "mobile"
      ? ""
      : getFromStorage("user")
      ? JSON.parse(getFromStorage("user"))
      : "",
  login: "",
  forgotUserMail: "",
  newPassword: "",
  resetPasswordCode: "",
  isLoading: true,
  error: "",
  selectedEmployee: false,
  twilioStatus: platform == "mobile"
  ? ""
  : getFromStorage("twilioStatus")
  ? getFromStorage("twilioStatus")
  : false,
  activeAccount:
    platform == "mobile"
      ? ""
      : getFromStorage("activeAccount")
      ? getFromStorage("activeAccount")
      : false,
};

const authReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SELECT_ACTIVE_ACCOUNT:
      return { ...state, activeAccount: action.payload };
    case SYNC_USER_INFO:
      return {
        ...state,
        isLoading: false,
        error: "",
        user: action.payload.user,
        login: action.payload.login,
        activeAccount: action.payload.activeAccount,
      };
    case LOGIN_USER:
      return { ...state, isLoading: true, error: "" };
    case LOGIN_USER_SUCCESS:
      return { ...state, isLoading: false, user: action.payload, error: "" };
    case LOGIN_USER_API_SUCCESS:
      return { ...state, login: action.payload };
    case LOGIN_USER_ERROR:
      return {
        ...state,
        isLoading: false,
        user: null,
        error: action.payload.message,
      };
    case FORGOT_PASSWORD:
      return { ...state, isLoading: true, error: "" };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        forgotUserMail: action.payload,
        error: "",
      };
    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        isLoading: false,
        forgotUserMail: "",
        error: action.payload.message,
      };
    case RESET_PASSWORD:
      return { ...state, isLoading: true, error: "" };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        newPassword: action.payload,
        resetPasswordCode: "",
        error: "",
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        isLoading: false,
        newPassword: "",
        resetPasswordCode: "",
        error: action.payload.message,
      };
    case REGISTER_USER:
      return { ...state, isLoading: true, error: "" };
    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        user: action.payload.uid,
        error: "",
      };
    case REGISTER_USER_ERROR:
      return {
        ...state,
        isLoading: false,
        user: "",
        error: action.payload.message,
      };
    case LOGOUT_USER:
      return { ...state, user: null, login: null, error: "" };
    case UPDATE_SELECTED_EMPLOYEE:
      return { ...state, selectedEmployee: action.payload };
    case "TWILIO":
      return { ...state, twilioStatus: action.payload };
    default:
      return { ...state };
  }
};

export default authReducer;
